<template>
  <div class="register-form">
    <div v-if="loading">
      <div v-if="!finished" class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
      <div v-else="">
        <span class="alert alert-success">
          <i class="fa fa-check"></i>
          <span class="help is-success">{{mensaje_ok}}</span>
        </span>

      </div>
    </div>

    <span v-if="mensaje_error" class="alert alert-danger">
      <i class="fa fa-check"></i>
      <span class="help is-success">{{mensaje_error}}</span>
    </span>

     <form v-show="!loading" @submit.prevent="validarRegistro" data-vv-scope="registerform">
       <div class="column is-12 ">
           <label class="label">Email (Obligatorio)</label>
           <p class="control has-icon has-icon-right">
               <input name="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('registerform.email') }" type="email" >
               <span v-show="errors.has('registerform.email')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('registerform.email') }}</span>
               </span>
           </p>
       </div>
       <div class="column is-12">
           <label class="label">Nombre completo (Obligatorio)</label>
           <p class="control has-icon has-icon-right">
               <input name="nombre_completo" v-model="nombre_completo" data-vv-as="Nombre Completo" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('registerform.nombre_completo') }" type="text" >
               <span v-show="errors.has('registerform.nombre_completo')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('registerform.nombre_completo') }}</span>
               </span>
           </p>
       </div>
       <div class="column is-12">
           <label class="label">Teléfono (Obligatorio)</label>
           <p class="control has-icon has-icon-right">
               <input name="telefono" v-model="telefono" data-vv-as="Teléfono" v-validate="'required|numeric|min:9|max:15'" :class="{'input': true, 'is-danger': errors.has('registerform.telefono') }" type="number" >
               <span v-show="errors.has('registerform.telefono')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('registerform.telefono') }}</span>
               </span>
           </p>
       </div>
       <div class="column is-12">
           <label class="label">Código postal</label>
           <p class="control has-icon has-icon-right">
               <input name="cp" v-model="cp" data-vv-as="Código postal" v-validate="'numeric|min:5|max:5'" :class="{'input': true, 'is-danger': errors.has('registerform.cp') }" type="text" >
               <span v-show="errors.has('registerform.cp')" class="alert alert-danger">
                 <i class="fa fa-exclamation-triangle"></i>
                 <span class="help is-danger">{{ errors.first('registerform.cp') }}</span>
               </span>
           </p>
       </div>

       <div class="column is-12">
         <p class="control">
             <label class="checkbox">
                 <input name="terms" v-model="terms"  data-vv-as="Condiciones de uso y política de privacidad" v-validate="'required'" type="checkbox" style="width:15px;height:15px;float:left;">
                 <p>Acepto las <a href="/condiciones-uso" target="_blank">condiciones de uso</a>, <a href="/politica-privacidad" target="_blank">política de privacidad</a> y <a href="/consentimiento-lopd" target="_blank">consentimiento de la ley de protección de datos</a>. </p>
             </label>
             <span v-show="errors.has('registerform.terms')" class="alert alert-danger">
               <i class="fa fa-exclamation-triangle"></i>
               <span class="help is-danger">{{ errors.first('registerform.terms') }}</span>
             </span>
         </p>
       </div>
       <div class="column is-12">
              <input name="submit" type="submit" class="btn" value="Registrarse">
       </div>
    </form>
  </div>
</template>
<div class="mensaje_ok" v-if="finished">
    <h1>Gracias por registrarse en Dsimobility</h1>
    <p>En breve recibirá un correo que deberá validar, para poder finalizar el proceso de registro.</p>
</div>
<script type='text/javascript' src='http://ajax.googleapis.com/ajax/libs/jquery/1.3.2/jquery.min.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue-resource@1.3.5"></script>
<script>

// Load the full build.
// var _ = require('lodash')
// var debounce = require('lodash/debounce')
// import registrojs from '../registro.js'
// var VueReCaptcha = require( 'vue-recaptcha-v3');
// Vue.use(VueReCaptcha, { siteKey: '6Lclt8EUAAAAAJNrsh1CGLO8P9C2NlCpSlh2LVNg'});

// For more options see below

export default {
  name: 'FormRegistro',
  props: ['api_key'],
  data () {
    return {
      newsletter: 1,
      terms: null,
      email: '',
      nombre_completo: '',
      telefono: '',
      cp: '',
      loading: false,
      finished: false,
      mensaje_error: '',
      mensaje_ok: '',
      captcha: '',
      url: '',
      link: ''

    }
  },
  methods: {
    validarRegistro: function () {
      this.mensaje_error = ''
      this.mensaje_ok = ''
      this.errors.clear()
      this.$validator.validateAll('registerform').then((result) => {
        console.log('Dentro de validar')
        console.log(result)
        if (result) {
          this.loading = true
          // eslint-disable-next-line
          var that = this;

          // this.$recaptcha('login').then((token) => {
          // console.log(token); // Will print the token
          // this.captcha=token;
          // console.log(this.captcha)
          // Comprobamos si el token es correcto

          // data.token = this.captcha;
          // var setHeader = {'Access-Control-Allow-Origin': '*'}
        (function($) {
          $.ajax({
            async: false,
            type: 'POST',
            url: that.link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/register.php',
            data: { email: that.email, nombre: that.nombre_completo, telefono: that.telefono, cp: that.cp, newsletter: that.newsletter, terminos_reg: that.terms },
            crossDomain: true,
            dataType: 'json',
            //headers: setHeader,
            success: function (data) {
              console.log(data)
              if (data.status === 200) {
                console.log('Correcto')
                that.loading = false
                if (data.data.status !== 200) {

                  that.loading = false
                  that.mensaje_error = data.data.msg
                  console.log(that.mensaje_error)
                } else {
                  that.mensaje_ok = 'Gracias por registrarse. En breve recibirá un correo que deberá validar, para poder finalizar el proceso.'
                  that.loading = true
                  that.finished = true;
                }
                // console.log(that.localidad_listado_ent);
              } else {
                that.loading = false
                that.mensaje_error = 'Revisa los errores para continuar'
              }
            }
          })
        })(jQuery);
        return false
        }
      // alert('Correct them errors!');
      })
      // this.validaMatricula(that);
    },
    recaptcha () {
      this.$recaptcha('login').then((token) => {
        // console.log(token) // Will print the token
        this.captcha = token
        // console.log(this.captcha)
        // Comprobamos si el token es correcto
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Register.vue